<template>
  <v-card>
    <v-card-title class="align-center justify-center third white--text mb-4">Mettre à jour le stock</v-card-title>
    <v-card-text>
      <div class="d-flex flex-column">
        <div>
          <p class="text-h6"><b>Stock maximum du contrat:</b> {{ initialStock }} </p>
          <p class="text-h6"><b>Stock contractuel actuel:</b> {{ auxContract.remainingStock }} </p>
          <p class="text-h6"><b>Solde actuel des stocks:</b> {{ auxContract.remainingStockMinusReservations }} ({{ reservationQuantity }} réservation future)</p>
        </div>
        <v-text-field v-model="newStockQuantity" label="Nouvelle quantité de stock" :rules="stockInputRules" style="width: 50%;" color="third" />
        <v-textarea v-model="observation" color="third" outlined no-resize label="Observations" style="width: 100%;" />
      </div>
      <v-col class="d-flex justify-center">
        <v-btn class="white--text" width="200" color="third" :disabled="!isInputValid || !newStockQuantity || !observation" :loading="loading" @click="confirm">
          Enregistrer
        </v-btn>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { sendNotification } from '@/helpers/utils';
import { changeContractStockBalance } from '@/helpers/request';
import store from '@/store';

export default {
  props: {
    contract: { type: Object, default: () => ({}) },
    customer: { type: Object, default: () => ({}) },
    initialStock: { type: Number, default: 0 }
  },
  setup (props, { emit }) {
    const newStockQuantity = ref(null);
    const observation = ref(null);
    const loading = ref(false);
    const auxContract = ref({ ...props.contract });

    const reservationQuantity = computed(() => {
      if (!auxContract.value) return 0;
      return auxContract.value.remainingStock - auxContract.value.remainingStockMinusReservations;
    });

    const stockInputRules = computed(() => [
      v => !v || !props.initialStock || parseInt(v) <= props.initialStock || 'Impossible de définir plus de stock que celui initialement défini.',
      v => !v || parseInt(v) >= reservationQuantity.value || 'Ne peut pas définir un stock inférieur au nombre de réservations futures.'
    ]);

    const isInputValid = computed(() => {
      return stockInputRules.value.every(rule => rule(newStockQuantity.value) === true);
    });

    const confirm = async () => {
      if (!newStockQuantity.value || parseInt(newStockQuantity.value) > props.initialStock || parseInt(newStockQuantity.value) < reservationQuantity.value) {
        return;
      }
      loading.value = true;
      const response = await changeContractStockBalance(
        props.customer.uuid,
        auxContract.value.contractNumber,
        auxContract.value.remainingStock,
        parseInt(newStockQuantity.value),
        store.state.user.uuid,
        observation.value
      );
      loading.value = false;

      if (response.success) {
        sendNotification('success', 'Mise à jour des stocks réussie');
        const newStock = parseInt(newStockQuantity.value);
        const newStockMinusReservations = parseInt(newStock) - parseInt(reservationQuantity.value)
        auxContract.value = {
          ...auxContract.value,
          remainingStock: newStock,
          remainingStockMinusReservations: newStockMinusReservations
        };
        emit('stock-updated', {
          contractNumber: auxContract.value.contractNumber,
          newStock,
          remainingStockMinusReservations: newStockMinusReservations
        });
        emit('history-changed');
        newStockQuantity.value = null;
        observation.value = null;
      } else {
        sendNotification('error', 'Erreur de mise à jour du stock');
      }
    };

    return { newStockQuantity, observation, loading, auxContract, reservationQuantity, stockInputRules, isInputValid, confirm };
  }
};
</script>
